/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const PhoneBookIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="phone-book-icon">
      <path d="M21.5,0.5 L5.5,0.5 C4.396,0.5 3.5,1.396 3.5,2.5 C3.5,3.604 4.396,4.5 5.5,4.5 L21.5,4.5 L21.5,23.5 L5.5,23.5 C4.396,23.5 3.5,22.604 3.5,21.5 L3.5,2.5" />
      <path d="M5.5,2.5 L20.5,2.5" />
      <path d="M2.5,7.5 L4.5,7.5" />
      <path d="M2.5,10.5 L4.5,10.5" />
      <path d="M2.5,13.5 L4.5,13.5" />
      <path d="M2.5,16.5 L4.5,16.5" />
      <path d="M2.5,19.5 L4.5,19.5" />
      <path d="M14.5,14.5 L14.5,16 L17.038,16.726 C17.567,16.877 18,17.45 18,18 L18,19.5 L8,19.5 L8,18 C8,17.45 8.433,16.877 8.961,16.726 L11.5,16 L11.5,14.5" />
      <ellipse cx="13" cy="11.771" rx="3" ry="3.272" />
      <path d="M15.958,11.213 C15.458,11.713 14.039,11.674 13.5,10.671 C12.5,11.671 10.875,11.671 10.066,11.1" />
    </g>
  </svg>
);

export default PhoneBookIcon;
